// Wire values — the smart-linking service owns these strings, not the CMS.
export enum SmartLinkEntityType {
  FUND = 'fund',
  MANAGEMENT_GROUP = 'management_group',
  MANAGER = 'manager',
  SECTOR = 'sector',
  ASSET_CLASS = 'asset_class',
  INVESTMENT_TRUST = 'investment_trust',
}
